import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { useAllContractBeneficiaries } from '../../../../hooks';
import { mergeSelectedIntoBeneficiaryRows } from '../../../../utils/beneficiaryUtils';
import { BeneficiariesModal } from '../../../CardTrackingPage/components/BeneficiariesModal';
export function RechargeBeneficiariesModal({ show, onHide, voucherContractId, selectedBeneficiaries, showAmount, amountSuffix, showGlobalValue, globalValue, }) {
    const needsFetch = Boolean(voucherContractId && selectedBeneficiaries.length > 0);
    const { beneficiaries: contractRows, isLoading, isError, } = useAllContractBeneficiaries({
        contractId: voucherContractId,
        enabled: needsFetch,
    });
    const beneficiariesForModal = useMemo(() => {
        if (!selectedBeneficiaries.length) {
            return [];
        }
        if (!voucherContractId || isError) {
            return [];
        }
        if (isLoading) {
            return [];
        }
        return mergeSelectedIntoBeneficiaryRows(contractRows, selectedBeneficiaries);
    }, [selectedBeneficiaries, voucherContractId, contractRows, isLoading, isError]);
    return (_jsx(BeneficiariesModal, { show: show, onHide: onHide, beneficiaries: beneficiariesForModal, showAmount: showAmount, amountSuffix: amountSuffix, showGlobalValue: showGlobalValue, globalValue: globalValue }));
}
